<template>
    <p-modal name="BarcodeListModal"
             label="Add Barcode"
            size="lg"
             @ok="okBarcode"
             @cancel="cancelBarcode"
             @hidden='handleModalHidden'
             @shown='handleModalShown'>
        <div class="container-fluid">
            <b-row>
                <b-col cols="6">
                    <p-input label="Barcode"
                             v-model="newBarcode"
                             rules="max:40|alphanumeric"
                             >
                        <template v-slot:append>
                            <b-button class="ms-0 px-1"
                                      style="white-space:nowrap;"
                                       @click="addBarcode">Add</b-button>
                        </template>
                    </p-input>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col>
                    <p-table :items="variant.barcodes"
                             :fields="barcodeFields"
                             :enableRowSelection="false"
                             rowClass="barcode-row"
                             @row-clicked="selectDefaultBarcode">
                        <template v-slot:cell(isDefault)="{ value, item }">
                            <div class="d-flex align-items-center" style="padding-left: 2.3rem">
                                <input type="radio"
                                    class="form-check-input"
                                    style="pointer-events: none;"
                                    name="defaultBarcode"
                                    :value="item.barcode"
                                    v-model="variant.defaultBarcode" />
                            </div>
                        </template>
                        <template v-slot:cell(delete)="{ value, item }">
                            <b-button v-if="currentVariant.sku != item.barcode" class="p-1 ms-1 short-button" @click="deleteProduct(item)">
                                <BIconTrash icon="trash"></BIconTrash>
                            </b-button>
                        </template>
                    </p-table>
                </b-col>
            </b-row>
        </div>
    </p-modal>
</template>

<script>
import axios from 'axios';
export default {
    emits: ['ok', 'cancel'],
    props: {
        currentVariant: Object,
        type: String,
        },
        data() {
            return {
                newBarcode: null,
                 variant: {
                     barcodes: [],
                     defaultBarcode: null
            },
            barcodeFields: [
                {
                    key: 'isDefault',
                    label: 'Default'
                },
                {
                    key: 'barcode',
                    label: 'Barcode'
                },
                    {
                    key: 'symbology',
                    label: 'Symbology'
                },
                {
                    key: 'delete',
                    label: 'Delete'
                },
            ],
        };
    },
    computed: {
    },
    methods: {
        addBarcode() {
            if (!this.newBarcode) { 
                this.$appError('Please enter barcode.')

                return;
            }
            
            if (this.newBarcode.length > 40) {
                this.$appError('Barcode length must be less then 40 .')
                return;
            }
            let count = (this.newBarcode.match(/^[0-9A-Za-z]+$/));
            if (!count) {
                this.$appError('This barcode can have only alphanumeric characters.')
                return;
            }
            if (this.variant.barcodes.some(x => x.barcode === this.newBarcode)) {
                 this.$appError('This barcode is already used by another product. It may not be used again.')
                return;
            }
            axios.get('products/addBarcode', { params: { barcode: this.newBarcode } }).then(resp => {
                if (resp && resp.data && resp.data.barcode) {
                        var self = this;
                        var newBarcodeItem = resp.data;
                        newBarcodeItem.isDefault = !self.variant.defaultBarcode;
                        self.variant.barcodes.push(newBarcodeItem);
                        self.variant.barcodes = this.sortBarcodes(self.variant.barcodes);
                        this.newBarcode = '';
                    }
                });
        },
        selectDefaultBarcode(item) {
            this.variant.defaultBarcode = item.barcode;
        },
           deleteProduct(item) {
                if (item.barcode === this.variant.defaultBarcode ) {
                    this.$appError('Please select a new default barcode before deletion.')
                    return;
                }
                  var currentBarcode = this.variant.barcodes.indexOf(item);
                  if (currentBarcode > -1) {
                      this.variant.barcodes.splice(currentBarcode, 1);
                  }
        },
        okBarcode() {
            this.variant.barcodes.forEach(x => x.isDefault = x.barcode === this.variant.defaultBarcode);
            this.$emit('ok', this.variant);
        },
        cancelBarcode() {
            this.$emit('cancel', this.variant);
        },
          handleModalHidden() {
            this.variant.barcodes =[] ;
            this.variant.defaultBarcode = null;
            this.newBarcode= null;
        },
        handleModalShown() {
            this.variant.barcodes = this.sortBarcodes(this.currentVariant.barcodes.map(b => ({ ...b })));

            this.variant.defaultBarcode = this.currentVariant.defaultBarcode;
            this.variant.barcodes.forEach(x => {
                x.isDefault = x.barcode === this.variant.defaultBarcode;
            });
        },
        sortBarcodes(barcodes) {
            return barcodes.sort((a, b) => a.barcode.localeCompare(b.barcode));
        }
    }
}
</script>

<style scoped>
:deep(tr.barcode-row) {
    cursor: pointer;
}
</style>
